import { cx } from "shared/utils";

type Props = {
  group?: boolean;
  title: string;
  className?: string;
};

export const GroupTypeLabel = ({ title, className }: Props) => {
  return <label className={cx("font-medium", className)}>{title}</label>;
};
